import { createApp } from "vue";
import App from "./App.vue";
// import Carousel from 'ant-design-vue'
import { Col, Row } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "./rem";

export const ossBaseUrl = 'https://909th-service.oss-cn-hangzhou.aliyuncs.com/image'

const app = createApp(App);
app.mount("#app");
app.use(Col, Row);
